module.exports = "https://s.pinimg.com/webapp/style/images/CS@2x-124e7fc0.png";